module.exports = __webpack_public_path__ + "img/img7.9b97502f.svg";